import { makeAutoObservable, runInAction } from 'mobx'
import axios, { AxiosError } from 'axios'
import RootStore from './root'
import { isLocalhost } from '../serviceWorkerRegistration'
import queryString from 'query-string'
import { ResUserInfo, ResUserData, ReqUserInfo, HttpReq } from '../common'

export class AuthStore {
  rootStore: RootStore
  userInfo: ResUserInfo | null | undefined = undefined

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  /**
   * OAuth 로그인 기능(1/2)
   * @param provider "google" | "kakao" | "naver" 중 선택 입력
   */
  async oAuthSignIn(provider: string, lastUrl: string) {
    try {
      const resRaw = await axios.get(`/auth/web/url`, {
        params: { provider: provider, local: isLocalhost ? true : undefined },
      })
      const resData: { url: string } = await resRaw.data
      window.location.href = `${resData.url}&state=${lastUrl}`
    } catch (err: unknown) {
      console.log(err as AxiosError)
    }
  }

  /**
   * OAuth 로그인 기능(2/2)
   * @param provider "google" | "kakao" | "naver" 중 선택 입력
   * @param rawParams 서버로부터 전달 받은 params
   * @param push 검증 성공시 페이지 이동을 위한 react-router 기능
   */
  async oAuthVerify(
    provider: 'google' | 'kakao' | 'naver',
    rawParams: string,
    push: (location: string, state?: unknown) => void,
  ) {
    if (rawParams == null || rawParams.length < 1) {
      return
    }
    const params = queryString.parse(rawParams)
    const resData = await HttpReq<ResUserData>({
      method: 'GET',
      url: `/auth/web/verify`,
      data: { provider: provider, code: params.code, state: params?.state, local: isLocalhost ? true : undefined },
    })
    if (resData?.isSignup == null) {
      return push('/')
    }
    const userInfo = await this.getUserInfo()
    if (userInfo == null) {
      return push('/')
    }
    if (resData?.isSignup === true) {
      return push('/signUp')
    }
    if (userInfo) {
      return push('/')
    }
    return push(typeof params.state === 'string' ? params.state : '/')
  }

  async getUserInfo(isReflash?: boolean): Promise<ResUserInfo | null> {
    if (this.userInfo != null && !isReflash) {
      return this.userInfo
    }
    let resData: ResUserInfo
    try {
      const resRaw = await axios.get(`/user/current`, { withCredentials: true })
      resData = await resRaw.data
    } catch (err: unknown) {
      runInAction(() => {
        this.userInfo = null
      })
      return null
    }
    runInAction(() => {
      this.userInfo = resData
    })
    return resData
  }

  updateUserInfo(updateUserInfo: ResUserInfo) {
    if (this.userInfo != null && updateUserInfo != null) {
      this.userInfo = updateUserInfo
    }
    return null
  }

  signOut = async () => {
    const resRaw = await axios.get(`/auth/logout`, { withCredentials: true })
    if (resRaw == null) {
      return
    }
    return resRaw.status
  }

  deleteUserInfo = () => {
    this.userInfo = null
  }

  signUp = async (data: ReqUserInfo): Promise<ResUserInfo | null> => {
    const updateUserInfo = await HttpReq<ResUserInfo>({
      method: 'PUT',
      url: `/user`,
      data: data,
    })
    if (updateUserInfo != null) {
      this.userInfo = updateUserInfo
    } else {
      return null
    }
    return updateUserInfo
  }
}
